import * as Types from 'src/actions/user/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import User from 'src/entities/User';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetUserAttempt extends Action {
  type: Types.GET_USER_ATTEMPT;
}

export interface GetUserSuccess extends Action {
  type: Types.GET_USER_SUCCESS;
  payload: User;
}

export interface GetUserFailure extends Action {
  type: Types.GET_USER_FAILURE;
  payload: {};
}

export type GetUserAction = GetUserAttempt | GetUserSuccess | GetUserFailure;

export interface GetUserThunk extends ThunkAction<Promise<GetUserAction>, RootState, null> {
}

export const getUserAttempt: ActionCreator<GetUserAttempt> = () => (
  { type: Types.GET_USER_ATTEMPT }
);

export const getUserSuccess: ActionCreator<GetUserSuccess> = (user: User) => (
  {
    type: Types.GET_USER_SUCCESS,
    payload: user
  }
);

export const getUserFailure: ActionCreator<GetUserFailure> = (error: {}) => (
  {
    type: Types.GET_USER_FAILURE,
    payload: error
  }
);

export const getUser: ActionCreator<GetUserThunk> = (
  userId: number
): GetUserThunk => {

  return (dispatch: Dispatch<RootState>): Promise<GetUserAction> => {
    dispatch(getUserAttempt());

    return ApiClient.user.get(userId)
      .then((response: AxiosResponse<User>): GetUserSuccess => {

        const user: User = response.data;

        return dispatch(getUserSuccess(user));
      }).catch((e: { response: { data: { error: {} } } }): GetUserFailure => {
        const errors = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

        return dispatch(getUserFailure(errors));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/user/get/GetUser.actions.tsx